function norelviGridText(grid,key,fallback){try{return JSON.parse(grid?.dataset.gridTexts||'{}')[key]||fallback;}catch{return fallback;}}

if(!window.NorelviSavedVariantsInstalled){
  window.NorelviSavedVariantsInstalled=true;
  const updateSaved=(button,saved)=>{button.setAttribute('aria-pressed',String(saved));};
  document.addEventListener('click',event=>{
    const button=event.target.closest('[data-save-variant]');if(!button)return;
    const grid=button.closest('.n-variant-grid');const status=grid.querySelector('[data-save-status]');
    try{const saved=JSON.parse(localStorage.getItem('norelvi-saved-variants')||'[]');const id=button.dataset.saveVariant;const next=saved.includes(id)?saved.filter(item=>item!==id):[...saved,id];localStorage.setItem('norelvi-saved-variants',JSON.stringify(next));updateSaved(button,next.includes(id));status.textContent=next.includes(id)?norelviGridText(grid,'saved','Auf diesem Gerät gemerkt.'):norelviGridText(grid,'removed','Von der Merkliste dieses Geräts entfernt.');}
    catch{status.textContent=norelviGridText(grid,'save_error','Die Merkliste kann in diesem Browser nicht gespeichert werden.');}
  });
  const initSaved=()=>{try{const saved=JSON.parse(localStorage.getItem('norelvi-saved-variants')||'[]');for(const button of document.querySelectorAll('[data-save-variant]'))updateSaved(button,saved.includes(button.dataset.saveVariant));}catch{}};
  document.addEventListener('shopify:section:load',initSaved);initSaved();
}

/* A hero choice supplies actual Shopify-rendered variant links to an unbound grid.
   Explicit grid products remain independent. No price or product data is invented. */
if (!window.NorelviHeroGridInstalled) {
  window.NorelviHeroGridInstalled = true;
  const originals = new WeakMap();
  const originalClosings = new WeakMap();
  const synchronize = () => {
    const source = document.querySelector('template[data-hero-variant-grid]');
    for(const closing of document.querySelectorAll('[data-follow-hero-closing]')){
      const link=closing.querySelector('[data-follow-hero-product]');
      const picture=closing.querySelector('[data-follow-hero-image]');
      const image=picture?.querySelector('img');
      const note=closing.querySelector('[data-follow-hero-note]');
      if(!link)continue;
      if(!originalClosings.has(closing))originalClosings.set(closing,{href:link.getAttribute('href'),hidden:link.hidden,image:image?.cloneNode(true)});
      const original=originalClosings.get(closing);
      if(source?.dataset.productUrl){
        link.setAttribute('href',source.dataset.productUrl);link.hidden=false;
        if(note)note.hidden=true;
        if(image && source.dataset.productImage){image.src=source.dataset.productImage;image.removeAttribute('srcset');image.alt=source.dataset.productTitle||'';}
      }else{
        if(original.href)link.setAttribute('href',original.href);else link.removeAttribute('href');
        link.hidden=original.hidden;if(note)note.hidden=false;
        if(picture && original.image)picture.replaceChildren(original.image.cloneNode(true));
      }
    }

    for (const grid of document.querySelectorAll('[data-grid-section]')) {
      const cards = grid.querySelector('.n-variant-grid__cards');
      const count = grid.querySelector('[data-grid-count]');
      if (!cards || !count || grid.dataset.gridProduct) continue;
      if (!originals.has(grid)) originals.set(grid, {cards:[...cards.childNodes].map(node=>node.cloneNode(true)),count:count.textContent});
      if (!source) {
        if (grid.dataset.heroProduct) {
          const original=originals.get(grid);
          cards.replaceChildren(...original.cards.map(node=>node.cloneNode(true)));
          count.textContent=original.count;
          delete grid.dataset.heroProduct;
        }
        continue;
      }
      const fragment=source.content.cloneNode(true);
      const overrides=[...grid.querySelectorAll('template[data-grid-override]')];
      for (const card of fragment.querySelectorAll('[data-variant-card]')) {
        const title=card.querySelector('h3');
        const label=card.querySelector('.n-variant-grid__label');
        const button=card.querySelector('[data-save-variant]');
        const cardId=`VariantCard-${grid.dataset.gridSection}-${card.dataset.variantCard}`;
        if(title) title.id=cardId;
        card.setAttribute('aria-labelledby',cardId);
        const override=overrides.find(item=>{
          const scope=item.dataset.productId ? item.dataset.productId===source.dataset.productId : source.dataset.productId===grid.dataset.routineId;
          if(!scope) return false;
          return item.dataset.variantId ? item.dataset.variantId===card.dataset.variantCard : !!item.dataset.variantTitle && item.dataset.variantTitle===card.dataset.variantTitle;
        });
        if (override) {
          const image=override.content.querySelector('img');
          const overrideLabel=override.content.querySelector('[data-grid-override-label]');
          const metadata=override.content.querySelector('[data-grid-override-meta]');
          if(image) card.querySelector('.n-variant-grid__media a')?.replaceChildren(image.cloneNode(true));
          if(overrideLabel){
            const name=overrideLabel.textContent;
            if(label)label.textContent=name;
            const subtitle=title?.querySelector('span');
            if(subtitle)subtitle.textContent=name;
            if(button)button.setAttribute('aria-label',norelviGridText(grid,'save_label','__NAME__ auf diesem Gerät merken').replaceAll('__NAME__',name));
            card.querySelector('img')?.setAttribute('alt',name);
          }
          for(const attr of metadata?.attributes||[])if(attr.name.startsWith('data-shopify-editor-'))card.setAttribute(attr.name,attr.value);
        }
        try {
          const saved=JSON.parse(localStorage.getItem('norelvi-saved-variants')||'[]');
          if(button)button.setAttribute('aria-pressed',String(Array.isArray(saved)&&saved.includes(button.dataset.saveVariant)));
        } catch { /* The native links work even when storage is unavailable. */ }
      }
      cards.replaceChildren(fragment);
      count.textContent=norelviGridText(grid,Number(source.dataset.variantCount)===1?'count_one':'count_many','__COUNT__ Ausführungen · ein Produkt').replaceAll('__COUNT__',source.dataset.variantCount);
      grid.dataset.heroProduct=source.dataset.productId;
    }
  };
  document.addEventListener('shopify:section:load',synchronize);
  document.addEventListener('shopify:section:unload',()=>setTimeout(synchronize,0));
  document.addEventListener('shopify:section:reorder',synchronize);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',synchronize,{once:true});
  else synchronize();
}
